import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DatiqSliderComponent } from './components/datiq-slider/datiq-slider.component';
import { NgxSliderModule } from 'ngx-slider-v2';
import { DatiqSliderSelectedDirective } from './directives/datiq-slider-selected.directive';
import { DatiqSliderRangeComponent } from './components/datiq-slider-range/datiq-slider-range.component';

@NgModule({
    declarations: [
        DatiqSliderComponent,
        DatiqSliderSelectedDirective,
        DatiqSliderRangeComponent,
    ],
    imports: [CommonModule, NgxSliderModule],
    exports: [
        DatiqSliderComponent,
        DatiqSliderSelectedDirective,
        DatiqSliderRangeComponent,
    ],
})
export class DatiqSliderModule {}
